import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton'
import Modal from 'components/imported/Modal'
import { useHistory } from 'react-router-dom'
import styles from './Auth.module.sass'
import LoginWithEmail from './AuthWithEmail'
import LoginWithPassword from './AuthWithPassword'
import LoginOtp from './AuthOtp'
import { actions } from './AuthReducer'
import * as AuthSelector from './AuthSelector'
import PageLoader from 'components/PageLoader'
import cx from 'classnames'

const { closeLoginModal } = actions
const {
  getShouldOpenModal,
  getWaitingOTPModal,
  getLoading,
  getIsVerifyingOtp
} = AuthSelector

const Auth = () => {
  const openModal = useSelector(getShouldOpenModal)
  const waitingOTP = useSelector(getWaitingOTPModal)
  const isLoading = useSelector(getLoading)
  const isOtpLoading = useSelector(getIsVerifyingOtp)
  const history = useHistory()
  const dispatch = useDispatch()
  const [useEmail, setUseEmail] = useState(true)
  const [usePassword, setUsePassword] = useState(false)
  const handleClose = path => {
    setUseEmail(true)
    setUsePassword(false)
    dispatch(closeLoginModal())
    history.replace(path || '/')
  }

  return (
    <>
      {isOtpLoading && <PageLoader />}
      <Modal
        modalOpen={openModal}
        style={{
          maxWidth: '535px',
          width: 'calc(100% - 10px)'
        }}
      >
        <div className={styles.loginModal}>
          <IconButton
            className={cx(
              styles.closeModal,
              isLoading && styles.disabledButton
            )}
            onClick={() => handleClose()}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') handleClose()
            }}
            disabled={isLoading}
            data-testid="closeBtn"
          >
            <svg
              style={{ height: '15px', width: '15px', fill: '#3b78c3' }}
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="CloseIcon"
            >
              <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            </svg>
          </IconButton>
          <div style={{ height: '6px' }}></div>
          {!waitingOTP && useEmail && <LoginWithEmail />}
          {waitingOTP && useEmail && <LoginOtp />}
          {usePassword ? (
            <>
              <LoginWithPassword />
              {!isLoading && (
                <button
                  className={styles.loginPasswordLink}
                  onClick={() => {
                    setUseEmail(true)
                    setUsePassword(false)
                  }}
                >
                  Log In Using Email
                </button>
              )}
            </>
          ) : (
            !isLoading && (
              <button
                className={styles.loginPasswordLink}
                onClick={() => {
                  setUsePassword(true)
                  setUseEmail(false)
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setUsePassword(true)
                    setUseEmail(false)
                  }
                }}
              >
                Log In Using Password
              </button>
            )
          )}
          <div className={styles.dividerline}></div>
          <div className={styles.loginCaption2Text}>
            Don’t have an account with
            <br />
            Answers in CME?
          </div>
          <button
            className={cx(styles.loginBtn2, isLoading && styles.disableInput)}
            onClick={() => handleClose('/signup')}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') handleClose('/signup')
            }}
          >
            Create an Account
          </button>
        </div>
      </Modal>
    </>
  )
}

export default Auth
